import { TabList, Tabs, Tab, TabPanels, TabPanel, Box } from '@chakra-ui/react';
import { CollaboratorResults } from 'app/components/GlobalSearch/CollaboratorResults';
import { SongResults } from 'app/components/GlobalSearch/SongResults';
import { ProfileCard } from 'types/profile';
import { Song } from 'types/song';
import { useAppSelector } from 'app/store';
import { getPlayerHeight } from 'app/store/AudioPlayer/selectors';
import { LoadingState } from './LoadingState';
import { EmptyState } from './EmptyState';

interface GlobalSearchContentProps {
  loading: boolean;
  isEmpty: boolean;
  search: string;
  tabIndex: number;
  collaborators: ProfileCard[];
  songs: Song[];
  searchByCollaborator?: ProfileCard;
  handleTabsChange: (index: number) => void;
}

export const GlobalSearchContent = ({
  loading,
  isEmpty,
  search,
  tabIndex,
  collaborators,
  songs,
  searchByCollaborator,
  handleTabsChange,
}: GlobalSearchContentProps) => {
  const playerHeight = useAppSelector(getPlayerHeight);

  if (loading) {
    return <LoadingState />;
  }

  if (isEmpty) {
    return <EmptyState search={search} />;
  }

  if (searchByCollaborator) {
    return <SongResults songs={songs} />;
  }

  const playerSpacer = <Box h={`${playerHeight}px`} />;
  return (
    <Tabs
      variant="soft-rounded"
      size="xs"
      index={tabIndex}
      defaultIndex={0}
      onChange={handleTabsChange}
    >
      <TabList h={8}>
        <Tab>All</Tab>
        <Tab isDisabled={!collaborators.length}>
          Collaborators ({collaborators.length})
        </Tab>
        <Tab isDisabled={!songs.length}>Songs ({songs.length})</Tab>
      </TabList>
      <TabPanels pb={6}>
        <TabPanel>
          {collaborators.length > 0 && (
            <CollaboratorResults
              pt={6}
              collaborators={collaborators.slice(0, 12)}
              topResults
            />
          )}
          {songs && songs.length > 0 && (
            <SongResults
              pt={6}
              pb={`${playerHeight}px`}
              songs={songs.slice(0, 12)}
            />
          )}
          {playerSpacer}
        </TabPanel>
        <TabPanel>
          {collaborators.length > 0 && (
            <CollaboratorResults pt={6} collaborators={collaborators} />
          )}
          {playerSpacer}
        </TabPanel>
        <TabPanel>
          {songs && songs.length > 0 && <SongResults pt={6} songs={songs} />}
          {playerSpacer}
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
